<template>
    <div 
    v-if="settings.display_progress_bar"
    class="progress"
    :style="'height:'+height+'px'">

        <div 
        class="progress-bar" 
        :class="theme"
        role="progressbar" 
        :style="'width:'+value+'%'" 
        :aria-valuenow="value" 
        aria-valuemin="0" 
        aria-valuemax="100">

            <span v-if="!light">
                {{value}}%
            </span>

        </div> <!-- /.progress-bar -->

    </div> <!-- /.progress -->
</template>

<script>

    import {mapState, mapGetters} from 'vuex'

    export default {
        
        props: {

            light: {
                type: Boolean,
                default: false
            },

            theme: {
                type: String,
                default: ''
            },

            section: {
                type: Number,
                default: null
            }
        },

        computed: {

            ...mapState({
                settings: state => state.form.settings
            }),

            ...mapGetters('form', [
                'progress'
            ]),

            height() {
                return this.light ? 4 : 20
            },

            value() {
                return this.section 
                ? this.progress.sections[this.section].percentage
                : this.progress.percentage
            }
        },


    }
</script>